$(".category_slider").slick({
    dots: false,
	infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
	slidesToShow: 3,
    arrows: true,
    centerMode: false,
	responsive: [
        {
        breakpoint: 1440,
            settings: {
                slidesToShow: 3,
            }
        },
        {
        breakpoint: 991,
            settings: {
                slidesToShow: 2,
            }
        },
        {
        breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.about_slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 7000,
  pauseOnHover: false,
  arrows: false,
  dots: false,
  cssEase: 'linear',
  responsive: [
        {
        breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        {
        breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
});

$(".review_slider").slick({
    dots: false,
	infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
	slidesToShow: 4,
    arrows: true,
    centerMode: false,
	responsive: [
        {
        breakpoint: 1580,
            settings: {
                slidesToShow: 3,
            }
        },
        {
        breakpoint: 1199,
            settings: {
                slidesToShow: 2,
            }
        },
        {
        breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});

// Header Search Start
const input = document.getElementById('search-input');

function triggerSearch() {
  const query = input.value.trim();
  if (!query) return;

  const searchUrl = `/search?q=${encodeURIComponent(query)}`;
  window.location.href = searchUrl;
}

let typingTimer;
input.addEventListener('input', () => {
  clearTimeout(typingTimer);
  typingTimer = setTimeout(triggerSearch, 75000);
});

// When page loads, restore the search query in the input field
const params = new URLSearchParams(window.location.search);
if (params.has('q')) {
  input.value = params.get('q');
}
// Header Search END


// Product Page Search Filter Start
var checkavailable = document.querySelector(".product_listing");
if (checkavailable) {
  const searchInput = document.getElementById('search-input1');
  const searchButton = document.getElementById('search-button1');

  searchButton.addEventListener('click', function () {
    let query = searchInput.value.trim();

    // If empty search → show all products
    if (!query) {
      query = '*';
    }

    fetch(`/search?q=${encodeURIComponent(query)}&view=ajax`)
      .then(res => res.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const newGrid = tempDiv.querySelector('#product-grid');
        const currentGrid = document.querySelector('#product-grid');

        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }
      });
  });
}

// Product Page Search Filter END

// Description & Review Tab Start
$('.desc-review .tab-menu ul li a').on('click', function(){
    var target = $(this).attr('data-rel');
    $('.desc-review .tab-menu ul li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".desc-review .tab-box").hide();
    return false;
});
// Description & Review Tab END

// Related Product Slider
document.addEventListener('DOMContentLoaded', function () {
  const recommendations = document.querySelector('product-recommendations');

  if (recommendations) {
    const observer = new MutationObserver(function () {
      const slider = document.querySelector('.related-products-slick');

      if (slider && typeof jQuery !== 'undefined' && typeof jQuery(slider).slick === 'function') {
        if (!jQuery(slider).hasClass('slick-initialized')) {
          jQuery(slider).slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 4,
            arrows: true,
            centerMode: false,
            responsive: [
                {
                breakpoint: 1580,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
          });
        }
      }
    });

    observer.observe(recommendations, { childList: true, subtree: true });
  }
});
// Related Product Slider END

// Product Search Page Start
const skuInput = document.getElementById('sku-search-input');

function triggerSKUSearch() {
  const skuQuery = skuInput.value.trim();
  if (!skuQuery) return;

  const searchUrl = `/search?q=${encodeURIComponent(skuQuery)}`;
  window.location.href = searchUrl;
}

let skuTypingTimer;
skuInput.addEventListener('input', () => {
  clearTimeout(skuTypingTimer);
  skuTypingTimer = setTimeout(triggerSKUSearch, 2000);
});

// Product Search Page END